import { render, staticRenderFns } from "./other-guardian-consent.vue?vue&type=template&id=202ab292&lang=pug&"
import script from "./other-guardian-consent.vue?vue&type=script&lang=js&"
export * from "./other-guardian-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202ab292')) {
      api.createRecord('202ab292', component.options)
    } else {
      api.reload('202ab292', component.options)
    }
    module.hot.accept("./other-guardian-consent.vue?vue&type=template&id=202ab292&lang=pug&", function () {
      api.rerender('202ab292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/otherGuardianConsent/other-guardian-consent.vue"
export default component.exports